import { EventStageState, Transition } from './types';
import { Broadcast } from '../event/types';

import loggerService from '@/services/logger.service';

const mutations = {
  setHeartBeat(state: EventStageState, value: Date) {
    state.heartBeatDate = value;
  },
  setHeartBeatInterval(state: EventStageState, value: any) {
    state.heartBeatInterval = value;
  },
  toggleEngagementPanel(state: EventStageState, value?: boolean) {
    if (typeof value === 'boolean') {
      state.showEngagementPanel = value;
      return;
    }
    state.showEngagementPanel = !state.showEngagementPanel;
  },
  clearHeartBeatInterval(state: EventStageState) {
    if (state.heartBeatInterval) {
      clearInterval(state.heartBeatInterval);
    }

    state.heartBeatInterval = null;
  },
  setTransition(state: EventStageState, value: Transition) {
    state.transitions = {
      ...state.transitions,
      [value.item.id]: value
    };
    state.transitions[value.item.id] = value;
  },
  removeTransition(state: EventStageState, value: Transition) {
    const newTransitions = { ...state.transitions };
    delete newTransitions[value.item.id];
    state.transitions = newTransitions;
  },
  setFullScreen(state: EventStageState, value: boolean) {
    state.fullScreen = value;
  },
  toggleMobileChat(state: EventStageState) {
    state.showChatOnMobile = window.mobileCheck() && !state.showChatOnMobile;
  },
  toggleTVChat(state: EventStageState) {
    state.showChatOnTV = !state.showChatOnTV;
  },
  showViewAsAttendeeTooltip(state: EventStageState) {
    state.forceShowViewAsAttendeeTooltip = true;
    setTimeout(() => {
      state.forceShowViewAsAttendeeTooltip = false;
    }, 10000);
  },
  setEnableCaptions(state: EventStageState, data: { hasUserEnabledCaptions: boolean; channel: string }) {
    state.hasUserEnabledCaptions = data.hasUserEnabledCaptions;
    window.localStorage.setItem(`enableCaptions-${data.channel}`, data.hasUserEnabledCaptions.toString());
    loggerService.info('Toggling captions', { hasUserEnabledCaptions: data.hasUserEnabledCaptions });
  },
  setCaptionLanguage(state: EventStageState, captionLanguage: string) {
    state.captionLanguage = captionLanguage;
  },
  toggleIsVideoPlayerHovered(state: EventStageState, isHLSVideoPlayerHovered: boolean = false) {
    state.isHLSVideoPlayerHovered = isHLSVideoPlayerHovered;
  },
  setIsSimuliveTestBufferMessageShown(
    state: EventStageState,
    { currentBroadcast, isAuthorizedForBackstage }: { currentBroadcast: Broadcast; isAuthorizedForBackstage: boolean }
  ) {
    state.isSimuliveTestBufferMessageShown = !!(
      isAuthorizedForBackstage &&
      currentBroadcast?.broadcast_type === 'SIMULIVE' &&
      state.heartBeatDate &&
      state.heartBeatDate < currentBroadcast.expectedSimuliveTestRunVideoStartTime &&
      currentBroadcast.simulive_test_run_end_time
    );
  },
  toggleMuted(state: EventStageState) {
    state.muted = !state.muted;
    state.volume.stage.level = state.volume.stage.level === '0' ? '100' : '0';
  },
  toggleGreenRoomVideoMuted(state: EventStageState) {
    state.greenRoomVideoMuted = !state.greenRoomVideoMuted;
  },
  setMuted(state: EventStageState, value: boolean) {
    state.muted = value;
  },
  setUserProfileDropdownOpen(state: EventStageState, value: boolean) {
    state.userProfileDropdownOpen = value;
  },
  setTvWindow(state: EventStageState, value: Window) {
    if (!value) {
      state.tvWindow?.close();
    }
    window.name = JSON.stringify({
      open: !!value
    });
    state.tvWindow = value;
  },
  setTransitionToMainStage(state: EventStageState, value: boolean) {
    state.transitionToMainStage = value;
  },
  setConnectToBackstage(state: EventStageState, value: boolean) {
    state.connectToBackstage = value;
  },
  setBackStageVisibility(state: EventStageState, value: boolean) {
    state.backStageVisibility = value;
    if (value) {
      state.speakerNotesVisibility = false;
    }
  },
  setSpeakerNotesVisibility(state: EventStageState, value: boolean) {
    state.speakerNotesVisibility = value;
    if (value) {
      state.backStageVisibility = false;
    }
  },
  setUsePPTAnimations(state: EventStageState, value: boolean) {
    state.usePPTAnimations = value;
  },
  setSettingUpRunOfShow(state: EventStageState, value: boolean) {
    state.runOfShowSetup = {
      ...state.runOfShowSetup,
      isRunning: value
    };
  },
  setRunOfShowSeekPos(state: EventStageState, value: number) {
    state.runOfShowSetup = {
      ...state.runOfShowSetup,
      seekPosition: value
    };
  },
  setRunOfShowSetupVideoLength(state: EventStageState, value: number) {
    state.runOfShowSetup = {
      ...state.runOfShowSetup,
      duration: value
    };
  },
  setRunOfShowSetupIsPlaying(state: EventStageState, value: boolean) {
    state.runOfShowSetup = {
      ...state.runOfShowSetup,
      isPlaying: value
    };
  }
};

export default mutations;
export type EventStageMutations = typeof mutations;
